'use client';

import * as React from 'react';

/** Console sidebar expands at/above this width; below it shows icon-only rail. */
export const CONSOLE_SIDEBAR_EXPANDED_MIN_PX = 1024;

export function useResponsiveSidebarOpen(expandedMinPx = CONSOLE_SIDEBAR_EXPANDED_MIN_PX): boolean {
  const [open, setOpen] = React.useState(true);

  React.useEffect(() => {
    const media = window.matchMedia(`(min-width: ${expandedMinPx}px)`);
    const sync = () => setOpen(media.matches);
    sync();
    media.addEventListener('change', sync);
    return () => media.removeEventListener('change', sync);
  }, [expandedMinPx]);

  return open;
}
